import React, { useState, useEffect, useRef } from 'react';
import { CCol, CInput, CTextarea, CTooltip } from '@coreui/react';
import $axios from 'src/utils/axios';
import IP from '../../StoreGlobal/IP';
import { RequestHistoryEdit } from 'src/request/Materials';
import ThingsToConsider from '../aimhi-widgets/ThingToConsider';

const PrintPurchaseRequest = React.forwardRef((props, ref) => {
  let accessToken = localStorage.getItem('token');
  const company_id = parseInt(localStorage.getItem('company_id'));
  const Swal = require('sweetalert2');

  const [purchaseRequest, setpurchaseRequest] = useState([]);
  const [companyName, setCompanyName] = useState('');
  const [location, setLocation] = useState('');
  const [companyProfilePicture, setcompanyProfilePicture] = useState('');
  const [department, setDepartment] = useState('');
  const [positionReq, setPositionReq] = useState('Position');
  const [editPositionReq, setEditPositionReq] = useState(false);
  const [nameRequester, setNameRequester] = useState('Name of Requester');
  const [editNameReq, setEditNameReq] = useState(false);
  const inputRef = useRef({});

  useEffect(() => {
    let user_id = parseInt(localStorage.getItem('user_id'));
    setpurchaseRequest(props.purchaserequest?.items ?? []);
    getCompanyData(company_id);
    GetUsersById(user_id);
  }, [props.purchaserequest]);


  useEffect(() => {

    const focusIfEditing = (isEditing, refKey) => {
      if (isEditing) {
        const element = inputRef.current?.[refKey];
        if (element && typeof element.focus === 'function') {
          element.focus();
        }
      }
    }

    focusIfEditing(editNameReq, 'name');
    focusIfEditing(editPositionReq, 'position');
  }, [editNameReq, editPositionReq])

  const getCompanyData = (company_id) => {
    $axios
      .get(IP + `company/info/${company_id}`, {
        company_id,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then(function (response) {
        if (response.data.status == 1) {
          setCompanyName(response.data.response.name);
          setLocation(response.data.response.location);
          setcompanyProfilePicture(response.data.response.company_pic);
        } else {
          Swal.fire({
            icon: 'error',
            title: response.data.response,
            text: response.data.description,
            confirmButtonColor: '#23303D',
          });
        }
      });
  };

  const GetUsersById = (user_id) => {
    $axios
      .post(IP + 'account/user/info', {
        user_id,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then(function (response) {
        if (response.data.status == 1) {
          setDepartment(response.data.response.department);
        }
      });
  };

  const SavePositionReq = (e) => {
    if (e.key == 'Enter') {
      setEditPositionReq(!editPositionReq);
    }
  };

  const SaveNameRequester = (e) => {
    if (e.key == 'Enter') {
      setEditNameReq(!editNameReq);
    }
  };

  const editNotes = (index) => {
    let arr = [...purchaseRequest];
    arr[index]['edit'] = true;
    setpurchaseRequest(arr);
  };

  const noteChange = (e, index, tx_id) => {
    let arr = [...purchaseRequest];
    arr[index].notes = e.target.value;
    setpurchaseRequest(arr);

    let data = {
      tx_id: tx_id,
      notes: e.target.value,
    };

    RequestHistoryEdit(data).then((res) => {
    });
  };

  const noteOnBlur = (index) => {
    let arr = [...purchaseRequest];
    arr[index]['edit'] = false;
    setpurchaseRequest(arr);
  };

  const editUnits = (index) => {
    let arr = [...purchaseRequest];
    arr[index]['edit_units'] = true;
    setpurchaseRequest(arr);
  };

  const unitChange = (e, index, tx_id) => {
    let arr = [...purchaseRequest];
    arr[index].unit = e.target.value;
    setpurchaseRequest(arr);

    let data = {
      tx_id: tx_id,
      unit: e.target.value,
    };

    RequestHistoryEdit(data).then((res) => {
    });
  };

  const unitChangeOnBlur = (index) => {
    const prData = [...purchaseRequest];
    prData[index].edit_units = false;
    setpurchaseRequest(prData);
  }

  const itemName = purchaseRequest.map((data) => data.item);

  const getItemId = (item) => item.tx_id;
  const selectAllRef = useRef(null);
  const allItemIds = purchaseRequest.map((item) => getItemId(item)).filter((id) => id !== undefined && id !== null);
  const isAllSelected = allItemIds.length > 0 && allItemIds.every((id) => props.selectedMaterials?.includes(id));
  const isSomeSelected = allItemIds.some((id) => props.selectedMaterials?.includes(id)) && !isAllSelected;

  useEffect(() => {
    if (selectAllRef.current) {
      selectAllRef.current.indeterminate = isSomeSelected;
    }
  }, [isSomeSelected]);

  const handleSelectAllChange = () => {
    if (props.onToggleSelectAll) {
      props.onToggleSelectAll(allItemIds);
    } else if (props.onToggleSelectMaterial) {
      if (isAllSelected) {
        allItemIds.forEach((id) => {
          if (props.selectedMaterials?.includes(id)) {
            props.onToggleSelectMaterial(id);
          }
        });
      } else {
        allItemIds.forEach((id) => {
          if (!props.selectedMaterials?.includes(id)) {
            props.onToggleSelectMaterial(id);
          }
        });
      }
    }
  };

  const purchasetable = purchaseRequest.map((item, Index) => {
    const itemId = getItemId(item);
    const isSelected = props.selectedMaterials?.includes(itemId);

    return (
      <tr key={Index}>
        {props.isCancelMode && (
          <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
            <input
              type="checkbox"
              style={{ width: '18px', height: '18px', cursor: 'pointer' }}
              checked={!!isSelected}
              onChange={() => props.onToggleSelectMaterial && props.onToggleSelectMaterial(itemId)}
            />
          </td>
        )}
        <td>{Index + 1}</td>
        <td>{item.item}</td>
        <td>{item.qty}</td>
        <td onClick={() => editUnits(Index)}>
          {item['edit_units'] == true ? (
            <CTextarea
              onChange={(e) => unitChange(e, Index, item.tx_id)}
              onBlur={() => unitChangeOnBlur(Index)}
              value={item.unit}
            ></CTextarea>
          ) : (
            <CTooltip content="Click to edit unit">
              <span>{item.unit}</span>
            </CTooltip>
          )}
        </td>
        <td onClick={() => editNotes(Index)}>
          {item['edit'] == true ? (
            <CTextarea
              onChange={(e) => noteChange(e, Index, item.tx_id)}
              onBlur={() => noteOnBlur(Index)}
              value={item.notes}
            ></CTextarea>
          ) : (
            <CTooltip content="Click to edit note">
              <span>{item.notes}</span>
            </CTooltip>
          )}
        </td>
      </tr>
    );
  });

  return (
    <div ref={ref} style={{ padding: '10px' }}>
      <table className="table table-bordered" style={{ marginTop: '20px' }}>
        <tr style={{ fontWeight: 'bold' }}>
          <td colSpan={6} style={{ textAlign: 'center' }}>
            <img src={companyProfilePicture} style={{ width: '100px', height: '100px' }} />
            <div>
              <span>{companyName}</span>
            </div>
            <div>
              <span>{location}</span>
            </div>
            <div style={{ marginTop: '15px' }}>
              <span>Purchase Requisition</span>
            </div>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <div>
              <span style={{ fontWeight: 'bold' }}>Department :</span>
              <span style={{ marginLeft: '5px' }}>{department}</span>
            </div>
            <div>
              <span style={{ fontWeight: 'bold' }}>Project Name :</span>
              <span style={{ marginLeft: '5px' }}>{props.project_name}</span>
            </div>
          </td>
          <td colSpan={3} style={{ textAlign: 'right' }}>
            <div>
              <span style={{ fontWeight: 'bold' }}>Date Requested :</span>
              <span style={{ marginLeft: '5px' }}>{props.purchaserequest?.date_requested ?? ''}</span>
            </div>
            <div>
              <span style={{ fontWeight: 'bold' }}>Pr Number :</span>
              <span style={{ marginLeft: '5px' }}>{props.purchaserequest?.pr_num ?? ''}</span>
            </div>
          </td>
        </tr>
      </table>
      <table className="table table-bordered" style={{ marginTop: '20px' }}>
        <thead>
          <tr>
            {props.isCancelMode && (
              <th style={{ textAlign: 'center', verticalAlign: 'middle', whiteSpace: 'nowrap' }}>
                <CTooltip content={isAllSelected ? 'Deselect all items' : 'Select all items'}>
                  <div
                    style={{
                      display: 'inline-flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      cursor: 'pointer',
                      userSelect: 'none'
                    }}
                    onClick={handleSelectAllChange}
                  >
                    <span>
                      Remove<br />
                      <span className="text-xs">(Select All)</span>
                    </span>

                    <input
                      ref={selectAllRef}
                      type="checkbox"
                      style={{
                        width: '18px',
                        height: '18px',
                        cursor: 'pointer',
                        marginTop: '4px'
                      }}
                      checked={isAllSelected}
                      onChange={handleSelectAllChange}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </div>
                </CTooltip>
              </th>
            )}
            <th>Item</th>
            <th>Item Description</th>
            <th>Quantity</th>
            <th>Unit</th>
            <th>Notes (optional)</th>
          </tr>
        </thead>
        <tbody>{purchasetable}</tbody>
      </table>
      <table className="table table-bordered">
        <tbody style={{ textAlign: 'center' }}>
          <tr style={{ fontSize: '12px' }}>
            <td>Requested by:</td>
            <td>Prepared by:</td>
            <td style={{ width: '300px' }}>Notes: </td>
            <td>Date Approved:</td>
            <td colSpan={2}>Approved by:</td>
          </tr>
          <tr style={{ fontSize: '12px' }}>
            <td style={{ verticalAlign: 'bottom', height: '60px' }}>
              {editNameReq ? (
                <CInput innerRef={(el) => (inputRef.current['name'] = el)} type="text" value={nameRequester} onChange={(e) => setNameRequester(e.target.value)} onKeyPress={(e) => SaveNameRequester(e)} onBlur={() => setEditNameReq(!editNameReq)} />
              ) : (
                <CTooltip content="Click to edit name">
                  <span onClick={() => setEditNameReq(!editNameReq)} className="pointer">
                    {nameRequester}
                  </span>
                </CTooltip>
              )}
            </td>
            <td style={{ verticalAlign: 'bottom' }}>{props.purchaserequest?.preparer}</td>
            <td>{props.purchaserequest?.notes}</td>
            <td rowSpan={2} style={{ verticalAlign: 'bottom' }}>
              {props.purchaserequest?.date_approved}
            </td>
            <td colSpan={2} rowSpan={2} style={{ verticalAlign: 'bottom' }}>
              {props.purchaserequest?.approver}
              <div>
                <span>{props.purchaserequest?.position}</span>
              </div>
            </td>
          </tr>
          <tr style={{ fontSize: '12px' }}>
            <td>
              {editPositionReq ? (
                <CInput innerRef={(el) => (inputRef.current['position'] = el)} type="text" onChange={(e) => setPositionReq(e.target.value)} value={positionReq} onKeyPress={(e) => SavePositionReq(e)} onBlur={() => setEditPositionReq(!editPositionReq)} />
              ) : (
                <CTooltip content="Click to edit position" placement='bottom'>
                  <span onClick={() => setEditPositionReq(!editPositionReq)} className="pointer">
                    {positionReq}
                  </span>
                </CTooltip>
              )}
            </td>
            <td>{props.purchaserequest?.preparer_position ?? ''}</td>
          </tr>
        </tbody>
      </table>
      <CCol xs="12" sm="12" md="12" lg="12" xl="12" style={{ padding: '0px' }}>
        <ThingsToConsider forPrinting={true} filterItems={itemName} />
      </CCol>
    </div>
  );
});

export default PrintPurchaseRequest;
